var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.1106 10.1106L15 15","stroke":"#212355","strokeWidth":"1.25","strokeLinecap":"round","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.25 11.5C9.14949 11.5 11.5 9.14949 11.5 6.25C11.5 3.35051 9.14949 1 6.25 1C3.35051 1 1 3.35051 1 6.25C1 9.14949 3.35051 11.5 6.25 11.5Z","stroke":"#212355","strokeWidth":"1.25","key":1})]);
}

SearchInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
